"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbSessionStorage = exports.MbSession = void 0;
/* eslint-disable complexity */
const timeOut_helper_1 = require("../../../features/timeOut/helpers/timeOut.helper");
const framework_1 = require("../../../framework");
const events_1 = require("../../../features/events");
const storage_1 = require("./storage");
Object.defineProperty(exports, "MbSessionStorage", { enumerable: true, get: function () { return storage_1.MbSessionStorage; } });
class MbSession extends framework_1.BaseSession {
    constructor(storage, urlConfig, eventBus) {
        super(storage);
        this.updateData = (newData) => {
            super.updateData(newData);
            (0, events_1.publishUpdatedDataSessionEvent)(newData, this.eventBus);
        };
        this.doRefresh = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)(undefined, this.eventBus);
                const actualSessionInfo = {
                    refreshToken: (_a = this.getData()) === null || _a === void 0 ? void 0 : _a.refreshToken,
                    username: (_b = this.getData()) === null || _b === void 0 ? void 0 : _b.username,
                };
                //TODO: Logic to make recalls
                const { data: { accessToken, sessionExpiresAt, expiresIn, refreshToken }, } = yield this.xhr.POST(this.urlConfig.refreshToken, actualSessionInfo);
                //TODO: add DDD architecture to avoid endpoints and transformations here
                const newSessionData = {
                    accessToken,
                    sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null,
                    expiresIn,
                    refreshToken: refreshToken !== null && refreshToken !== void 0 ? refreshToken : actualSessionInfo.refreshToken,
                    username: (_d = (_c = this.getData()) === null || _c === void 0 ? void 0 : _c.username) !== null && _d !== void 0 ? _d : '',
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn),
                    customerSessionId: (_f = (_e = this.getData()) === null || _e === void 0 ? void 0 : _e.customerSessionId) !== null && _f !== void 0 ? _f : '',
                };
                (0, events_1.publishRefreshedSessionEvent)(newSessionData, this.eventBus);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e, this.eventBus);
                throw e;
            }
        });
        this.isSessionExpired = (sessionData) => {
            if (sessionData.timeOutStamp) {
                return sessionData.timeOutStamp <= Date.now();
            }
            return false;
        };
        this.isDataValid = (sessionData) => {
            if (sessionData.accessToken && sessionData.refreshToken && sessionData.username && !this.isSessionExpired(sessionData)) {
                return true;
            }
            return false;
        };
        this.xhr = null;
        this.urlConfig = urlConfig;
        this.eventBus = eventBus;
    }
    setXHR(newXhr) {
        this.xhr = newXhr;
    }
    initSession(initData) {
        super.initSession(initData);
        (0, events_1.publishUpdatedDataSessionEvent)(initData, this.eventBus);
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback, this.eventBus);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback, this.eventBus);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback, this.eventBus);
    }
    onUpdatedData(callback) {
        return (0, events_1.subscribeUpdatedDataSessionEvent)(callback, this.eventBus);
    }
}
exports.MbSession = MbSession;
//# sourceMappingURL=index.js.map